import { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AlertTriangle, Loader, Trash2 } from 'lucide-react';
import { deleteMe, clearSession } from '../../../services/auth.api';

const field = {
  width: '100%',
  padding: '9px 12px',
  borderRadius: 8,
  border: '1.5px solid #e5e7eb',
  fontSize: 13,
  fontFamily: "'Inter', sans-serif",
  background: '#f9fafb',
  outline: 'none',
  boxSizing: 'border-box',
};

export default function AccountSettingsTab() {
  const [password, setPassword] = useState('');
  const [reason, setReason] = useState('');
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    if (!password) {
      toast.error('Enter your password to confirm.');
      return;
    }
    if (!window.confirm('Delete your OwnFood account? This cannot be undone.')) return;

    try {
      setDeleting(true);
      await deleteMe({ password, reason: reason.trim() || undefined });
      clearSession();
      toast.success('Your account has been deleted.');
      window.location.href = '/';
    } catch (err) {
      toast.error(err?.message || 'Could not delete your account.');
      setDeleting(false);
    }
  };

  return (
    <div className="prof-card" style={{ border: '1.5px solid #fee2e2' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <AlertTriangle size={16} color="#dc2626" />
        <p className="prof-card-label" style={{ margin: 0, color: '#dc2626' }}>Danger Zone</p>
      </div>
      <p style={{ margin: '4px 0 18px', fontSize: 13, color: '#6b7280' }}>
        Deleting your account removes your profile, saved addresses, favourites and
        notifications, and signs you out everywhere. It's permanent and can't be undone.
        {' '}An order in progress, a pending withdrawal, or a wallet balance will block
        deletion until it's resolved. See the full{' '}
        <Link to="/delete-account" style={{ color: '#0d6efd' }}>account deletion policy</Link>.
      </p>

      <form onSubmit={handleDelete} style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 380 }}>
        <input
          style={field}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Enter your password to confirm"
          autoComplete="current-password"
          required
        />
        <input
          style={field}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="Reason (optional)"
          maxLength={500}
        />

        <button
          type="submit"
          disabled={deleting}
          style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
            padding: '10px 16px', borderRadius: 8, border: 'none', alignSelf: 'flex-start',
            background: deleting ? '#f3a6a6' : '#dc2626', color: '#fff', fontSize: 13, fontWeight: 700,
            cursor: deleting ? 'not-allowed' : 'pointer', fontFamily: "'Inter', sans-serif",
          }}
        >
          {deleting ? <Loader size={14} className="prof-spin" /> : <Trash2 size={14} />}
          {deleting ? 'Deleting…' : 'Delete my account'}
        </button>
      </form>
    </div>
  );
}
